export const TimeIntervals = {
  PERIOD_HOUR: {
    title: 'prices.filter.1h',
    value: 'hourData',
    period: 'hour',
  },
  PERIOD_DAY: {
    title: 'prices.filter.day',
    value: 'dayData',
    period: 'day',
  },
  PERIOD_WEEK: {
    title: 'prices.filter.week',
    value: 'weekData',
    period: 'week',
  },
  PERIOD_MONTH: {
    title: 'prices.filter.month',
    value: 'monthData',
    period: 'month',
  },
  PERIOD_THREE_MONTHS: {
    title: 'prices.filter.3months',
    value: 'tMonthData',
    period: 'three_months',
  },
  PERIOD_SIX_MONTHS: {
    title: 'prices.filter.6months',
    value: 'sMonthsData',
    period: 'six_months',
  },
  PERIOD_YEAR: {
    title: 'prices.filter.year',
    value: 'yearData',
    period: 'year',
  },
  PERIOD_THREE_YEARS: {
    title: 'prices.filter.3years',
    value: 'tYearsData',
    period: 'three_years',
  },
};

export const CryptoCompareData = {
  NOT_AVAILABLE: 'N/A',
}

export const Markets = [
  {
    title: 'prices.filter.market.all',
    value: 'CCCAGG',
  },
  {
    title: 'prices.filter.market.kraken',
    value: 'Kraken',
  },
  {
    title: 'prices.filter.market.bitfinex',
    value: 'Bitfinex',
  },
  {
    title: 'prices.filter.market.binance',
    value: 'Binance',
  },
];

export const FiatCurrency = [
  {
    title: 'USD',
    value: 'USD',
  },
  {
    title: 'EUR',
    value: 'EUR',
  },
  {
    title: 'CAD',
    value: 'CAD',
  },
  {
    title: 'GBP',
    value: 'GBP',
  },
  {
    title: 'JPY',
    value: 'JPY',
  },
  {
    title: 'AUD',
    value: 'AUD',
  },
  {
    title: 'CHF',
    value: 'CHF',
  },
  {
    title: 'RUB',
    value: 'RUB',
  },
  {
    title: 'TRY',
    value: 'TRY',
  },
  {
    title: 'CZK',
    value: 'CZK',
  },
  {
    title: 'DKK',
    value: 'DKK',
  },
  {
    title: 'NOK',
    value: 'NOK',
  },
  {
    title: 'NZD',
    value: 'NZD',
  },
  { title: 'PLN', value: 'PLN' }, { title: 'SEK', value: 'SEK' }, { title: 'ZAR', value: 'ZAR' }, {
    title: 'HKD',
    value: 'HKD',
  }, { title: 'SGD', value: 'SGD' }, { title: 'UAH', value: 'UAH' }, { title: 'AED', value: 'AED' }, {
    title: 'ALL',
    value: 'ALL',
  }, { title: 'AZN', value: 'AZN' }, { title: 'BDT', value: 'BDT' }, { title: 'BYN', value: 'BYN' }, {
    title: 'CRC',
    value: 'CRC',
  }, { title: 'DOP', value: 'DOP' }, { title: 'DZD', value: 'DZD' }, { title: 'EGP', value: 'EGP' }, {
    title: 'GEL',
    value: 'GEL',
  }, { title: 'HRK', value: 'HRK' }, { title: 'HUF', value: 'HUF' }, { title: 'INR', value: 'INR' }, {
    title: 'KRW',
    value: 'KRW',
  }, { title: 'KWD', value: 'KWD' }, { title: 'MAD', value: 'MAD' }, { title: 'MYR', value: 'MYR' }, {
    title: 'NGN',
    value: 'NGN',
  }, { title: 'PEN', value: 'PEN' }, { title: 'PHP', value: 'PHP' }, { title: 'RON', value: 'RON' }, {
    title: 'SAR',
    value: 'SAR',
  }, { title: 'THB', value: 'THB' }, { title: 'TND', value: 'TND' }, { title: 'VUV', value: 'VUV' }, {
    title: 'XAF',
    value: 'XAF',
  }, { title: 'ILS', value: 'ILS' }, { title: 'TWD', value: 'TWD' }, { title: 'BGN', value: 'BGN' }, {
    title: 'VND',
    value: 'VND',
  }, { title: 'KZT', value: 'KZT' }, { title: 'MDL', value: 'MDL' }, { title: 'QAR', value: 'QAR' }, {
    title: 'UZS',
    value: 'UZS',
  }, { title: 'JOD', value: 'JOD' }, { title: 'BHD', value: 'BHD' }, { title: 'NAD', value: 'NAD' }, {
    title: 'ARS',
    value: 'ARS',
  }, { title: 'BRL', value: 'BRL' },
];
